import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Store } from '../../Store';

// Gate for the whole product-manager area.
//
// Admins pass, the isProductManager role passes, and so does anyone an admin
// has granted one of the product-panel permissions. Everything below the panel
// still checks its own permission, and every endpoint re-checks against the
// database, so this only decides whether the browser renders the shell.
const PANEL_PERMISSIONS = [
  'canAddProduct',
  'canManageStock',
  'canPrintSticker',
  'canManageOrders',
  'canViewReports',
];

export default function ProductManagerRoute({ children }) {
  const { state } = useContext(Store);
  const { userInfo } = state;
  if (!userInfo) return <Navigate to="/signin" />;
  if (userInfo.isAdmin || userInfo.isProductManager) return children;
  const held = userInfo.permissions || {};
  return PANEL_PERMISSIONS.some((p) => held[p]) ? children : <Navigate to="/signin" />;
}
